export default {
  calendar: {
    today: 'Oggi',
    tomorrow: 'Domani',
    asap: 'Prima possibile',
  },
};
